module.exports = __webpack_public_path__ + "img/invoices_initial.1ffb7066.png";